import ModalFooter from "@/modules/common/components/modals/modal-footer";
import { muiTheme } from "@/styles/theme";
import CloseIcon from "@mui/icons-material/Close";
import { Box } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import Toolbar from "@mui/material/Toolbar";
import { TransitionProps } from "@mui/material/transitions";
import Typography from "@mui/material/Typography";
import { forwardRef } from "react";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

interface FullScreenDialogProps {
  children: React.ReactNode;
  setOpen: (boolean: boolean) => void;
  open: boolean;
  header?: string;
  handleConfirm?: () => void;
  isLoading?: boolean;
  disabledConfirmButton?: boolean;
  confirmText?: string;
  cancelText?: string;
  modalFooter?: boolean;
  enableEnterKeySubmit?: boolean;
  clearButton?: JSX.Element;
  applyButton?: JSX.Element;
  handleCloseModal?: () => void;
}
const FullScreenDialog: React.FC<FullScreenDialogProps> = ({
  children,
  open,
  setOpen,
  header: title,
  handleConfirm,
  isLoading,
  disabledConfirmButton,
  confirmText,
  cancelText,
  modalFooter,
  enableEnterKeySubmit,
  handleCloseModal,
  clearButton,
  applyButton,
}) => {
  const handleClose = () => {
    setOpen(false);
    handleCloseModal && handleCloseModal();
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "sticky", backgroundColor: "#CEDAEA" }}>
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography sx={{ color: "#015C9D" }} variant="body_bg_reg">
            {title}
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon
              style={{ color: "#015C9D", width: "40px", height: "40px" }}
            />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{ padding: 3, marginBottom: "82px", overflow: "auto" }}>
        {children}
      </Box>
      {modalFooter && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            bottom: "0",
            left: "0",
            right: "0",
            gap: 1,
            maxWidth: "100vw",
            backgroundColor:
              muiTheme.colorSchemes.light.palette.background.blue1,
            padding: 2,
            zIndex: 9,
          }}
        >
          <ModalFooter
            handleClose={handleClose}
            handleConfirm={handleConfirm}
            isSubmitting={isLoading}
            disabledConfirmButton={disabledConfirmButton}
            confirmText={confirmText ? confirmText : "Save"}
            cancelText={cancelText ? cancelText : "Cancel"}
            enableEnterKeySubmit={enableEnterKeySubmit}
            clearButton={clearButton ? clearButton : undefined}
            applyButton={applyButton ? applyButton : undefined}
          />
        </Box>
      )}
    </Dialog>
  );
};
export default FullScreenDialog;
